import asyncCom from '@/CommonDP/commons/asyncCom.js';

export function _isFolder(data) {
  return data.filter(item => item.isFolder === 1);
}

export const addDeptDialog = async (data) => {
  const { default: components } = await import("./enterpriseDeptDoc/dialog/deptDialog.vue");
  return await asyncCom(components, {}, data);
};

export const DocMoveAndCopyDialog = async (data) => {
  const { default: components } = await import("./enterpriseDeptDoc/dialog/moveAndCopy.vue");
  return await asyncCom(components, {}, data);
};

export const UserIdentity = {
  ISADIM: '1', // 管理员
  ISDEPT: '2', // 该部门
  ISOUT: '3'// 外部
};
